import * as Yup from 'yup';

const TITLE = ['Edit Category', 'Edit Tag', 'Create Category', 'Create Tag'];
export default Yup.object().shape({
  category: Yup.string().when(['modalTile'], {
    is: (modalTile) => TITLE.includes(modalTile),
    then: Yup.string().required('Field cannot be empty')
  })
});
